import { TopVotersResponse } from '@/core/user';
import { getChainConstant } from '@/domain/chain';
import { SubgraphUrl } from '@/domain/subgraph';
import useChainId from '@/hooks/useChainId';
import querySubgraph from '@/infrastructure/subgraph';
import { useQuery } from '@tanstack/react-query';

const useTopVoters = () => {
  const chainId = useChainId();

  return useQuery({
    queryKey: ['topVoters', chainId],
    queryFn: async () => {
      const data = await querySubgraph({
        url: getChainConstant(SubgraphUrl, chainId),
        query: `query TopVoters {
          users(where: { activeVotes_: { id_not: null }}) {
            activeVotes(where: { revoked: false } orderBy: votesCast orderDirection: desc) {
              id
              collection {
                name
                id
              }
              votesCast
              type
            }
            voteLock {
              amount
            }
            id
          }
        }`,
      });

      return (data?.users || []) as TopVotersResponse;
    },
  });
};

export default useTopVoters;
